import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import './index.less';

interface TeamCardInfo {
  id: number;
  teamName: string;
  englishName: string;
  description: string;
  rarity: 'SR' | 'UR' | 'SSR';
  thumbnailUrl?: string;
  totalId: number;
}

interface GroupedCards {
  [key: number]: {
    groupName: string;
    cards: TeamCardInfo[];
  };
}

const CardsPage: React.FC = () => {
  const navigate = useNavigate();
  const { hash } = useParams<{ hash: string }>();
  const [groupedCards, setGroupedCards] = useState<GroupedCards>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCards = async () => {
      try {
        const response = await axios.get('/api/v1/backroomsteamcard/info');
        const cards: TeamCardInfo[] = response.data;
        
        const totalIdToName: { [key: number]: string } = {};
        cards.forEach((card: TeamCardInfo) => {
          if (card.id === card.totalId) {
            totalIdToName[card.totalId] = card.teamName;
          }
        });

        const grouped: GroupedCards = {};
        cards.forEach((card: TeamCardInfo) => {
          if (!grouped[card.totalId]) {
            grouped[card.totalId] = {
              groupName: totalIdToName[card.totalId] || `Group ${card.totalId}`,
              cards: []
            };
          }
          grouped[card.totalId].cards.push(card);
        });

        setGroupedCards(grouped);
      } catch (error) {
        console.error('Error fetching cards:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCards();
  }, []);

  return (
    <div className='backrooms-team-cards-page'>
      <div className="back-button" onClick={() => navigate(`/card/${hash}`)}>
        &lt; 返回
      </div>

      {Object.entries(groupedCards).map(([totalId, group]) => (
        <div key={totalId} className="card-group">
          <div className="group-header">
            <h3 className="group-title">{group.groupName}，共{group.cards.length}张卡</h3>
          </div>
          <div className="cards-scroll-container">
            {group.cards.map((card: TeamCardInfo) => (
              <div key={card.id} className="card-item">
                <div className="card">
                  {card.thumbnailUrl && (
                    <img
                      alt={card.teamName}
                      src={card.thumbnailUrl}
                      className="card-image"
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CardsPage; 